import { render, staticRenderFns } from "./SignUpConfirmation.vue?vue&type=template&id=b16c5fee&scoped=true"
import script from "./SignUpConfirmation.vue?vue&type=script&lang=js"
export * from "./SignUpConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SignUpConfirmation.vue?vue&type=style&index=0&id=b16c5fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16c5fee",
  null
  
)

export default component.exports